import axios from 'axios';
const Token = JSON.parse(localStorage.getItem("token"))

export const LeaveCreateAPI = async (formData) =>
    await axios({
        method: 'POST',
        url: process.env.REACT_APP_API_URL + '/leaveRequest/',
        headers: {
            "Access-Control-Allow-Origin": "*",
            // "Content-type": "Application/json",
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${Token.access_token}`
        },
        data: formData,
    })

export const LeaveTypeAPI = async () =>
    await axios.get(process.env.REACT_APP_API_URL + '/leaveType/', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })


export const CheckTypeLeave = async (LeaveTypeId) =>
    await axios.get(process.env.REACT_APP_API_URL + '/leaveType/checkType/' + LeaveTypeId, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })


export const LeaveOfYearAPI = async (EmpNO) =>
    await axios.get(process.env.REACT_APP_API_URL + '/employee/leaveOfYear/' + EmpNO, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })

export const downloadFilesAPI = async (fileName) =>
    await axios.get(process.env.REACT_APP_API_URL + '/leaveRequest/download/files/' + fileName, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        },
        responseType: 'blob'
    })

// export const SendLeaveReqAPI = async (lId) =>
//     await axios({
//         method: 'patch',
//         url: process.env.REACT_APP_API_URL + '/leaveRequest/send/',
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-type": "Application/json",
//             "Authorization": `Bearer ${Token.access_token}`
//         },
//         data: { lId },
//     })

export const FindOne = async (id) =>
    await axios.get(process.env.REACT_APP_API_URL + '/leaveRequest/' + id, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })
